import * as CertificationWatermark from '@tableau/certification-watermark';
import { SiteUrls } from '@tableau/shared-urls';
import { DataGrid } from '@tableau/widgets-datagrid';
import { style } from 'typestyle';
import { MapperHelper } from '../../common/utils/MapperHelper';
import { UserMapper } from '../../common/utils/UserMapper';
import { HiddenUserStyles } from '../components/listView/dataGridCells/DataSourceType';
import { ICatalogUserItem } from '../models/httpClient/MetaDataResults';
import { IUser } from '../models/IUser';
import { ICatalogUserInfo, IDataQualityWarningAuthorInfo } from '../models/SearchResultTypes';

// The following function is copied from VPC.
export function generateDBAndTableCertificationTooltipProps(
  row: DataGrid.Row,
  urls: SiteUrls
): CertificationWatermark.CertificationTooltipProps {
  const contentDetail = row.data.contentDetail || row.data;
  const certifier = UserMapper.mapOne(contentDetail.certifier);
  const certificationNote = contentDetail.certificationNote ? contentDetail.certificationNote : '';
  const certificationDetails = {
    certificationNote: certificationNote,
    certifier: contentDetail.certifier,
    isCertified: contentDetail.isCertified,
  };
  certifier.displayName = contentDetail.certifier ? contentDetail.certifier.name : null;
  certifier.domainName = contentDetail.certifier ? contentDetail.certifier.domain : null;
  return (
    certificationDetails && {
      id: row.data.id,
      certifier: certifier && {
        customUserStyle: certifier.isHiddenInternalUser ? (HiddenUserStyles.HiddenUserStyle as React.CSSProperties) : {},
        displayName: certifier.displayName,
        url: certifier.domainName ? urls.userUrl(certifier.username, certifier.domainName) : '',
      },
      note: certificationDetails.certificationNote,
      date: MapperHelper.toDate(contentDetail.lastRefreshedAt),
    }
  );
}

export const IconStyle = style({
  $nest: {
    '&>div': {
      left: '9px !important',
      top: '3px !important',
    },
  },
});

export function mapCertifier(certifier?: ICatalogUserItem): ICatalogUserInfo | undefined {
  /* eslint-disable prettier/prettier */
  return certifier
    ? {
      id: certifier.id,
      name: certifier.displayName,
      username: certifier.username,
      domain: certifier.domainName,
      readOnly: !!certifier.readOnly,
      hasServerDisplay: certifier.hasServerDisplay,
    }
    : undefined;
  /* eslint-enable prettier/prettier */
}

export function mapDataQualityWarningOwnerToAuthor(dataQualityWarningOwner?: IUser): IDataQualityWarningAuthorInfo {
  const author: IDataQualityWarningAuthorInfo = {
    username: dataQualityWarningOwner?.username || '',
    name: dataQualityWarningOwner?.displayName || '',
    domain: dataQualityWarningOwner?.domainName || '',
    ...dataQualityWarningOwner,
  };
  return author;
}

export function mapDataQualityWarningUpdatedAt(updatedAt: string) {
  return updatedAt ? MapperHelper.toDate(updatedAt) : undefined;
}
